// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2rHtj","dragIcon":"SortableItem_dragIcon__i-Dm-","disabled":"SortableItem_disabled__2VTtg"};